import { Routes } from 'app/services/routeService/routeService'
import { AccessType } from 'app/auth/accessControlService'
import ResetPasswordPages from './ResetPasswordPages'

export const ResetPasswordConfig = {
  settings: {
    layout: {
      config: {
        navbar: {
          display: false,
        },
        toolbar: {
          display: false,
        },
        footer: {
          display: false,
        },
        leftSidePanel: {
          display: false,
        },
        rightSidePanel: {
          display: false,
        },
      },
    },
  },
  routes: [
    {
      path: Routes.resetPassword(),
      component: ResetPasswordPages,
      accesses: [AccessType.ANNONYMOUS],
    },
  ],
}
